import React, { useEffect, useState } from 'react';
import { Tab } from '@mui/material';
import { TabContext, TabList } from '@mui/lab';
import SwipeableViews from 'react-swipeable-views';
import { Colors } from '../../theme/Colors';

export default function Tabs({
    selectedTab,
    setSelectedTab,
    tabs,
    values,
}: {
    selectedTab: string;
    setSelectedTab: (value: string) => void;
    tabs: string[];
    values: JSX.Element[];
}) {
    const [visitedTabs, setVisitedTabs] = useState<Set<string>>(() => new Set([selectedTab]));

    useEffect(() => {
        setVisitedTabs((prev) => {
            if (prev.has(selectedTab)) {
                return prev;
            }
            const next = new Set(prev);
            next.add(selectedTab);
            return next;
        });
    }, [selectedTab]);

    const lazyValues = values.map((value, i) => (visitedTabs.has(i.toString()) ? value : <div key={value.key ?? i} />));

    return (
        <TabContext value={selectedTab}>
            <TabList
                onChange={(e, value) => setSelectedTab(value)}
                variant="scrollable"
                allowScrollButtonsMobile
                textColor="inherit"
                TabIndicatorProps={{ style: classes.tabIndicator }}
            >
                {tabs.map((t: string, i: number) => (
                    <Tab key={t} label={t} value={i.toString()} sx={classes.tabs} />
                ))}
            </TabList>
            <SwipeableViews
                index={parseInt(selectedTab)}
                onChangeIndex={(index: number) => setSelectedTab(index.toString())}
            >
                {lazyValues}
            </SwipeableViews>
        </TabContext>
    );
}

const classes = {
    tabs: {
        '&.MuiButtonBase-root.MuiTab-root': {
            fontSize: 16,
            fontWeight: 'bold',
            textTransform: 'none',
            outline: 'none',
            padding: '0 10px',
        },
        '&.MuiTab-textColorInherit': {
            color: Colors.primary,
        },
        '&.Mui-selected': {
            color: Colors.secondary,
        },
    },
    panels: {
        '&.MuiTabPanel-root': {
            paddingTop: '20px',
            paddingBottom: '20px',
        },
    },
    modal: {
        width: '80%',
        maxWidth: 'unset',
    },
    tabIndicator: {
        backgroundColor: Colors.secondary,
        height: 3,
    },
};
